import styled from 'styled-components'

import { Button } from '@/components'
import { FieldSet, Legend } from '@/components/Layout'
import { CheckBox } from '@/components/UberForm'

export const ObjectTypesFieldSet = styled(FieldSet)`
	margin-bottom: 15px;
	padding-bottom: 13px;
	max-height: 400px;
	overflow-x: auto;
	padding-top: 0;
`

export const StyledCheckbox = styled(CheckBox)`
	margin-left: 18px;
`

export const StyledLegend = styled(Legend)`
	letter-spacing: 0;
`

export const StructureTypeButton = styled(Button)`
	padding-top: 12px;
	font-size: 105%;
	padding-bottom: 6px;
	padding-left: 6px;
`
